(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["samo-home-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('samo-product-carousel')) {
  customElements.define('samo-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const track = this.querySelector('.samo-carousel__track');
      const slides = [...this.querySelectorAll('.samo-carousel__slide')];
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      const status = this.querySelector('.samo-carousel__status');
      const nav = this.querySelector('.samo-carousel__nav');
      if (!track || !slides.length) return;
      const desktop = matchMedia('(min-width: 990px)');
      const carouselRole = this.getAttribute('aria-roledescription');
      let index = 0, drag = null, moved = false, frame = null;
      const step = () => slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth;
      const update = () => {
        nav.hidden = desktop.matches || slides.length < 2;
        track.tabIndex = desktop.matches ? -1 : 0;
        if (desktop.matches) {
          slides.forEach(slide => { slide.inert = false; });
          this.removeAttribute('aria-roledescription');
          return;
        }
        if (carouselRole) this.setAttribute('aria-roledescription', carouselRole);
        index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / step())));
        prev.disabled = index === 0; next.disabled = index === slides.length - 1;
        status.textContent = `${index + 1} / ${slides.length}`;
        slides.forEach((slide, i) => { slide.inert = i !== index; });
      };
      const go = i => {
        if (desktop.matches) return;
        index = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({left: index * step(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      nav.hidden = slides.length < 2;
      prev.addEventListener('click', () => go(index - 1), {signal});
      next.addEventListener('click', () => go(index + 1), {signal});
      track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, {passive:true, signal});
      track.addEventListener('keydown', event => {
        if (desktop.matches || !['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
        event.preventDefault();
        go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
      }, {signal});
      track.addEventListener('pointerdown', event => {
        if (desktop.matches || event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = {x:event.clientX, scroll:track.scrollLeft, pointer:event.pointerId}; moved = false;
      }, {signal});
      track.addEventListener('pointermove', event => {
        if (!drag) return;
        const delta = event.clientX - drag.x;
        if (Math.abs(delta) > 8) { moved = true; track.setPointerCapture(drag.pointer); track.classList.add('is-dragging'); }
        if (moved) { event.preventDefault(); track.scrollLeft = drag.scroll - delta; }
      }, {signal});
      const finish = () => { if (!drag) return; drag = null; track.classList.remove('is-dragging'); if (moved) go(Math.round(track.scrollLeft / step())); };
      track.addEventListener('pointerup', finish, {signal});
      track.addEventListener('pointercancel', finish, {signal});
      track.addEventListener('pointerleave', event => { if (drag && !track.hasPointerCapture(event.pointerId)) finish(); }, {signal});
      track.addEventListener('click', event => { if (moved) { event.preventDefault(); event.stopPropagation(); moved = false; } }, {capture:true, signal});
      const resize = () => { drag = null; moved = false; track.classList.remove('is-dragging'); track.scrollTo({left:desktop.matches ? 0 : index * step(), behavior:'instant'}); update(); };
      desktop.addEventListener('change', resize, {signal});
      this.resizeObserver = new ResizeObserver(resize);
      this.resizeObserver.observe(track);
      this.cleanupFrame = () => cancelAnimationFrame(frame);
      update();
    }
    disconnectedCallback() { this.controller?.abort(); this.resizeObserver?.disconnect(); this.cleanupFrame?.(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
